import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createFinalAwardsAPI,
  updateFinalAwardsAPI,
  getFinalAwardsByCaseIDAPI,
  deleteFinalAwardsAPI,
} from "../../../api/finalAwards_api";

export const getFinalAwardsByCaseIDAction = createAsyncThunk(
  "finalAwards/getFinalAwardsByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getFinalAwardsByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createFinalAwardsAction = createAsyncThunk(
  "finalAwards/createFinalAwards",
  async (finalAwardsData, { rejectWithValue }) => {
    const response = await createFinalAwardsAPI(finalAwardsData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateFinalAwardsAction = createAsyncThunk(
  "finalAwards/updateFinalAwards",
  async ({ finalAwards_ID, finalAwardsData }, { rejectWithValue }) => {
    const response = await updateFinalAwardsAPI(
      finalAwards_ID,
      finalAwardsData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteFinalAwardsAction = createAsyncThunk(
  "finalAwards/deleteFinalAwards",
  async (finalAwards_ID, { rejectWithValue }) => {
    const response = await deleteFinalAwardsAPI(finalAwards_ID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
